import { collapseDrawer, expandDrawer } from '../utils/animation';
import { selectors } from '../utils/product';

export default class ProductDescription {
    constructor() {
        this.descriptionHeader = document.querySelector(
            selectors.description.header
        );
        this.descriptionBody = document.querySelector(
            selectors.description.body
        );
        this.descriptionAction = document.querySelector(
            selectors.description.action
        );
        this.addEventListeners();
    }

    addEventListeners() {
        this.descriptionAction.addEventListener('click', () => {
            if (this.descriptionBody.getAttribute('aria-expanded') === 'false') {
                expandDrawer(this.descriptionBody);
                this.descriptionBody.setAttribute('aria-expanded', 'true');
                this.descriptionAction.innerText = 'Minimal Description';
            } else {
                collapseDrawer(this.descriptionBody);
                this.descriptionBody.setAttribute('aria-expanded', 'false');
                this.descriptionAction.innerText = 'Full Description';
            }
        });
    }
}
